module.exports = __webpack_public_path__ + "static/images/components/ProductionProgress/images/cancel-button-active.6849ded9.png";


//////////////////
// WEBPACK FOOTER
// ./components/ProductionProgress/images/cancel-button-active.png
// module id = 2658
// module chunks = 11